module.exports = __webpack_public_path__ + "media/icons/chat-e0f60f7c.png";